import type { ReactNode } from 'react'
import { Button, Card, Field, StateBlock } from '@w7/ui'

export function BmPage({
  title,
  description,
  actions,
  children,
  error,
}: {
  title: string
  description?: string
  actions?: ReactNode
  children?: ReactNode
  error?: string | null
}) {
  return (
    <div style={{ display: 'grid', gap: 16 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 22 }}>{title}</h1>
          {description ? <p style={{ margin: '6px 0 0', opacity: 0.75 }}>{description}</p> : null}
        </div>
        {actions}
      </div>
      {error ? (
        <StateBlock icon="warning" title="Request failed">
          {error}
        </StateBlock>
      ) : null}
      {children}
    </div>
  )
}

export function BmJsonCard({ title, data }: { title: string; data: unknown }) {
  return (
    <Card>
      <h2 style={{ marginTop: 0, fontSize: 16 }}>{title}</h2>
      <pre style={{ margin: 0, whiteSpace: 'pre-wrap', fontSize: 12, maxHeight: 480, overflow: 'auto' }}>
        {JSON.stringify(data, null, 2)}
      </pre>
    </Card>
  )
}

export function BmForm({
  fields,
  values,
  onChange,
  onSubmit,
  submitLabel = 'Save',
  busy,
}: {
  fields: {
    key: string
    label: string
    type?: string
    placeholder?: string
    options?: { value: string; label: string }[]
  }[]
  values: Record<string, string>
  onChange: (key: string, value: string) => void
  onSubmit: () => void
  submitLabel?: string
  busy?: boolean
}) {
  return (
    <Card>
      <form
        onSubmit={(e) => {
          e.preventDefault()
          onSubmit()
        }}
        style={{ display: 'grid', gap: 12, maxWidth: 560 }}
      >
        {fields.map((f) => (
          <Field key={f.key} label={f.label}>
            {({ id, describedBy, invalid }) =>
              f.type === 'select' ? (
                <select
                  id={id}
                  aria-describedby={describedBy}
                  aria-invalid={invalid || undefined}
                  value={values[f.key] ?? ''}
                  onChange={(e) => onChange(f.key, e.target.value)}
                  style={{ width: '100%', padding: '8px 10px' }}
                >
                  <option value="">{f.placeholder || `Select ${f.label}`}</option>
                  {(f.options ?? []).map((o) => (
                    <option key={o.value} value={o.value}>
                      {o.label}
                    </option>
                  ))}
                </select>
              ) : (
                <input
                  id={id}
                  aria-describedby={describedBy}
                  aria-invalid={invalid || undefined}
                  value={values[f.key] ?? ''}
                  onChange={(e) => onChange(f.key, e.target.value)}
                  type={f.type ?? 'text'}
                  placeholder={f.placeholder}
                  style={{ width: '100%', padding: '8px 10px' }}
                />
              )
            }
          </Field>
        ))}
        <Button type="submit" disabled={busy}>
          {busy ? 'Working…' : submitLabel}
        </Button>
      </form>
    </Card>
  )
}
